import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Calendar, MapPin, Users, ArrowRight } from "lucide-react";
import PageHeader from "../components/site/PageHeader";
import { api } from "../lib/api";

export default function Events() {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    api.get("/events").then((r) => setEvents(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="events-page">
      <PageHeader
        eyebrow="Etkinlikler"
        title="Yaklaşan Organizasyonlar"
        subtitle="Festivaller, yetenek tarama günleri, kamplar ve özel etkinlikler için kayıt al, takvimini hazırla."
      />

      <section className="section-pad">
        <div className="container-x">
          {events.length === 0 ? (
            <div className="text-center text-muted-foreground py-20">Etkinlik yükleniyor...</div>
          ) : (
            <div className="grid lg:grid-cols-2 gap-5">
              {events.map((e) => (
                <Link
                  key={e.id}
                  to={`/etkinlikler/${e.id}`}
                  className="card-elev p-7 block group"
                  data-testid={`event-list-${e.id}`}
                >
                  <div className="flex flex-wrap items-center gap-2 mb-4">
                    <span className="badge-status-soon">{e.event_type}</span>
                    <span className="text-xs font-display uppercase tracking-[0.2em] text-muted-foreground">{e.branch}</span>
                  </div>
                  <h3 className="font-display text-3xl font-bold uppercase tracking-tight group-hover:text-primary transition-colors">
                    {e.name}
                  </h3>
                  <p className="mt-3 text-sm text-muted-foreground line-clamp-2 leading-relaxed">{e.description}</p>
                  <div className="mt-5 grid sm:grid-cols-2 gap-3 text-sm">
                    <Info icon={Calendar} text={`${e.date} · ${e.time}`} />
                    <Info icon={MapPin} text={e.location} />
                    <Info icon={Users} text={`Yaş: ${e.age_category}`} />
                    <Info icon={Users} text={`Kontenjan: ${e.capacity}`} />
                  </div>
                  <div className="mt-6 flex items-center justify-between border-t border-border pt-4">
                    <div>
                      <div className="text-[10px] font-display uppercase tracking-[0.22em] text-muted-foreground">Katılım</div>
                      <div className="font-display font-bold text-primary uppercase tracking-wider">{e.fee}</div>
                    </div>
                    <span className="inline-flex items-center gap-1 font-display text-sm font-bold uppercase tracking-wider text-primary">
                      Kayıt Ol <ArrowRight className="h-4 w-4" />
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}

function Info({ icon: Icon, text }) {
  return (
    <div className="flex items-center gap-2 text-muted-foreground">
      <Icon className="h-4 w-4 text-primary shrink-0" />
      <span>{text}</span>
    </div>
  );
}
